<template>
    <section :class="[
        'section',
        { 'section--full-height' : fullHeight },
        { 'section--no-padding' : noPadding },
        { 'section--full' : fullWidth }
    ]">
        <h1 class="section__title" v-if="title">{{ title }}</h1>
        <slot></slot>
    </section>
</template>

<script>
export default {
    props: {
        title: {
            type: String
        },
        fullHeight: {
            type: Boolean,
            default: false
        },
        fullWidth: {
            type: Boolean,
            default: false
        },
        noPadding: {
            type: Boolean,
            default: false
        }
    }
}
</script>
